import { createStandardAction } from 'typesafe-actions';
import { IVideoStyle } from './types';

const storeVideoThemeId = createStandardAction(
  'VIDEO_STYLE/SET_THEME_ID',
)<string>();

const storeVideoStyle = createStandardAction('VIDEO_STYLE/SET_STYLE')<
  Partial<IVideoStyle>
>();

const storeMusicTag = createStandardAction(
  'VIDEO_STYLE/SET_MUSIC_TAG',
)<string>();

const storeMusicTrackId = createStandardAction(
  'VIDEO_STYLE/SET_MUSIC_TRACK_ID',
)<string>();

const deactivateShortFlow = createStandardAction(
  'VIDEO_STYLE/DEACTIVATE_SHORT_FLOW',
)();

export {
  storeVideoThemeId,
  storeVideoStyle,
  storeMusicTag,
  storeMusicTrackId,
  deactivateShortFlow,
};
